import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheScrumMaster = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🧑‍🏫 Recruter un Scrum Master
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Scrum Master est le facilitateur de l’équipe agile. Il veille à la bonne application du cadre Scrum, à la fluidité des échanges entre les parties prenantes, et à l’amélioration continue du processus de développement. Véritable garant de la méthode, il aide l’équipe à gagner en efficacité, en autonomie et en cohésion tout au long des sprints.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Organiser et animer les cérémonies Scrum : daily meetings, sprint planning, reviews, rétrospectives</li>
          <li>Lever les obstacles rencontrés par l’équipe</li>
          <li>Assurer la communication entre les développeurs, le Product Owner et les métiers</li>
          <li>Accompagner l’équipe dans l’adoption des pratiques agiles</li>
          <li>Suivre l’avancement et la vélocité de l’équipe via les indicateurs agiles</li>
          <li>Promouvoir la culture agile au sein de l’organisation</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Maîtrise de Scrum, Kanban, SAFe ou LeSS</li>
          <li>Outils : Jira, Confluence, Trello, Miro</li>
          <li>Compétences en communication, écoute active, diplomatie</li>
          <li>Bonne compréhension des enjeux techniques et produit</li>
          <li>Capacité à faire monter l’équipe en maturité agile</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : animation des rituels, support à un Scrum Master senior</li>
          <li>Confirmé : autonomie sur plusieurs squads, gestion d’équipes pluridisciplinaires</li>
          <li>Senior / Coach Agile : accompagnement de l’organisation dans une démarche agile globale</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 350–450 € / jour</li>
          <li>Confirmé : 500–650 € / jour</li>
          <li>Senior / Coach Agile : 700–900 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheScrumMaster;
